<template>
  <div v-if="show" class="sidebar-links">
    <router-link to="/patients" :class="{active: isAllPatients}">All Patients</router-link>
    <router-link to="/patients/add-patients" :class="{active: isActiveAddPatients}">Add Patients & Surgeries</router-link>
    <router-link to="/patients/add-patient-preop" :class="{active: isActiveAddPatientPreop}">Add Patient & Pre-Op</router-link>
    <!--
    <router-link to="/patients/add-patient" :class="{active: isActiveAddPatient}">Add Patient</router-link>
    -->
  </div>
</template>

<script>
export default {
  computed: {
    path() {
      return this.$route.path
    },

    show() {
      return new RegExp('^/patients').test(this.path) ||
        new RegExp('^/operations').test(this.path) ||
        new RegExp('^/surgeons').test(this.path) ||
        new RegExp('^/users').test(this.path)
    },

    isActiveAddPatient() {
      return this.path === '/patients/add-patient'
    },

    isActiveAddPatients() {
      return this.path === '/patients/add-patients'
    },

    isActiveAddPatientPreop() {
      return this.path.startsWith('/patients/add-patient-preop')
    },

    isAllPatients() {
      return new RegExp('/patients').test(this.path) && 
        !this.isActiveAddPatients && !this.isActiveAddPatientPreop
    }
  }
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/SideNav/PatientsLinks.vue